import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import { reduceComponents } from './reduce-head';
import { HeadSideEffect } from './head-side-effect';
import { createHeadManager } from './head-manager';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '../../atom';
export const DATA_DYNAMIC_HEAD = 'data-dynamic';
export const initHeadManager = () => {
    window.headManager = createHeadManager();
};
export const StaticHead = (props) => {
    const { children } = props;
    if (__BUILD_TARGET__ === 'server') {
        return children;
    }
    return null;
};
export const DynamicHead = (props) => {
    const { children } = props;
    const { isBot } = useAtomValue($UserAgent);
    const filteredChildren = Children.toArray(children).filter((child) => !(isValidElement(child) && child.type === 'script' && child.props?.type === 'application/ld+json' && !isBot));
    if (__BUILD_TARGET__ === 'server') {
        const components = reduceComponents(filteredChildren);
        return components;
    }
    return (_jsx(HeadSideEffect, { reduceComponentsToState: reduceComponents, headManager: window.headManager, children: filteredChildren }));
};
